import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { ServiceFactory } from '../services/ServiceFactory';
import { selectors as authSelectors } from '../store/slices/authSlice';

export const accountQueryKey = ['account'];

const customerService = ServiceFactory.createCustomerService();

export const useAccount = () => {
  const isLoggedIn = useSelector(authSelectors.isLoggedIn);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!isLoggedIn) {
      // Invalidate account query when user is not logged in
      queryClient.invalidateQueries({ queryKey: accountQueryKey });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Changes in the queryClient are irrelevant for this hook
  }, [isLoggedIn]);

  const { data, status, error } = useQuery({
    queryKey: accountQueryKey,
    queryFn: () => customerService.getAccount(),
    enabled: isLoggedIn,
  });

  return {
    account: data,
    status,
    error,
  };
};
